import React from "react";

import config from "configs/app";
import useApiQuery from "lib/api/useApiQuery";
import StatsWidget from "src/components/stats/StatsWidget";

import styles from "./NumberWidgetsList.module.css";

const UNITS_WITHOUT_SPACE = ["s"];

const NumberWidgetsList = () => {
  const { data, isPlaceholderData, isLoading, isError } = useApiQuery(
    "stats_counters",
    {
      queryOptions: {},
    },
  );

  // API returns array directly, wrap it in counters object if needed
  const displayData = data
    ? Array.isArray(data)
      ? { counters: data }
      : data
    : { counters: [] };
  const showAsLoading = isLoading || isPlaceholderData;

  if (showAsLoading && displayData.counters.length === 0) {
    return (
      <div className={styles.grid}>
        {Array.from({ length: 16 }).map((_, i) => (
          <StatsWidget
            key={`skeleton-${i}`}
            label=""
            value=""
            isLoading={true}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {displayData.counters?.map(
        (
          {
            id,
            title: rawTitle,
            value,
            units: rawUnits,
            description: rawDescription,
          },
          index,
        ) => {
          const title = rawTitle?.replace(
            /\bETH\b/g,
            config.chain.currency.symbol,
          );
          const description = rawDescription?.replace(
            /\bETH\b/g,
            config.chain.currency.symbol,
          );
          const units =
            rawUnits === "ETH" ? config.chain.currency.symbol : rawUnits;

          let unitsStr = "";
          if (units && UNITS_WITHOUT_SPACE.includes(units)) {
            unitsStr = units;
          } else if (units) {
            unitsStr = " " + units;
          }

          const formattedValue = `${Number(value).toLocaleString(undefined, { maximumFractionDigits: 3 })}${unitsStr}`;

          return (
            <StatsWidget
              key={id + (showAsLoading ? index : "")}
              label={title}
              value={formattedValue}
              isLoading={false}
              hint={description}
            />
          );
        },
      )}
    </div>
  );
};

export default NumberWidgetsList;
